import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { signInThunk, initialStateUser } from '../../../store/slices/catalogs/users.slice';
//UI
import ShowPassword from '../../../components/Inputs/ShowPassword';
import logo from '../../../assets/peef.png';
import UserLogo from '../../../components/Inputs/UserLogo';
import { API_BASE_URL } from '../../../store/constans';
import MainLoader from '../../../components/Loaders/MainLoader';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';

const Login = () => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const { user, error } = useSelector(state => state.users);
  const { items } = useSelector(state => state.configurations);
  const isLoading = useSelector(state => state.isLoadingSlice);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getConfigsThunk());
    return (() => {
      dispatch(initialStateUser());
      dispatch(initialStateConfig())
    })
  }, []);

  const submit = (data) => {
    dispatch(signInThunk(data));
  }

  if (Object.keys(user).length !== 0) {
    let userInfo = {
      userName: user.firstName + " " + user.lastName,
      token: user.token,
      role: user.rol,
      id: user.id,
      logo: items[0]?.logo
    };
    if (user.changePassword) {
      navigate(`/panel/changePassword/${user.id}`)
    } else {
      if (user.rol === 'Administrador') {
        navigate("/panel/configurations");
      }
      if (user.rol === 'Secretaria') {
        navigate("/panel/students");
      }
      if (user.rol === 'Administrativo') {
        navigate("/panel/student_with_space");
      }
      if (user.rol === 'Médico') {
        navigate("/panel/reports/forms");
      }
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  }

  return (
    <>
      {isLoading ? (<MainLoader />) : (
        <div
          className={`text-gray-600 flex justify-center items-center 2xl:items-center h-full w-full min-h-screen bg-cover`}
          style={{ backgroundImage: `url(${API_BASE_URL + items[0]?.background})` }}
        >
          <div className="absolute top-0 left-0 w-full h-full bg-zinc-800/40 "></div>
          <div className="w-full md:w-[35%] bg-white/80 backdrop-blur-sm shadow-md shadow-gray-800 flex flex-col items-center justify-center rounded-md z-10">
            <div className='flex flex-col gap-2 w-full items-center justify-center p-4'>
              <img className='w-[280px] md:w-[180px]' src={API_BASE_URL + items[0]?.logo} alt="logo" />
              <h1 className="text-[25px] font-semibold mb-0 text-sky-700">¡Bienvenido administrador!</h1>
            </div>
            {error &&
              <div className='flex p-2 gap-1 text-left text-sm font-sans w-[80%] border-red-500 rounded-md border mt-6 bg-red-200 items-center'>
                <h1 className="mb-0">¡Error!</h1>
                <p className='mb-0'>{error}</p>
              </div>
            }
            <form onSubmit={handleSubmit(submit)} className="w-[75%] mx-auto text-gray-600 my-10 font-sans">
              <div className='flex flex-col'>
                <div className="relative flex flex-col mt-8">
                  <input className={'w-full placeholder-gray-600 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                    type='text'
                    {...register("email")}
                    placeholder="Email"
                  />
                  <UserLogo />
                </div>
                {errors.email && (<span className="error_message">{"Información requerida"}</span>)}
                <div className="relative flex flex-col mt-8">
                  <input className='w-full p-2 rounded-xl placeholder-gray-600 focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'
                    type={isPasswordHidden ? 'password' : 'text'}
                    {...register("password")}
                    placeholder="Password"
                  />
                  <ShowPassword
                    isPasswordHidden={isPasswordHidden}
                    setIsPasswordHidden={setIsPasswordHidden}
                  />
                </div>
                <div className='flex gap-2 w-[100%] mt-2 justify-end'>
                  <h1 className="text-[13px] flex gap-2"><Link to={'/panel/forgotPassword'}><p className='text-sky-700 hover:text-sky-800'>¿Has olvidado tu contraseña?</p> </Link></h1>
                </div>
              </div>
              <div className='flex w-full justify-center h-[35px] mt-10'>
                <button type=" submit" className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                  Iniciar sesión
                </button>
              </div>
            </form>
          </div>
          <div className="hidden md:flex md:flex-col md:absolute bg-white/80  md:left-[90%] md:top-[80%] z-10 p-2 rounded-md shadow-md shadow-gray-500">
            <img className='w-[280px] md:w-[100px]' src={logo} alt="logo" />
            <p className='font-semibold text-[13px]'>Proveedor Oficial</p>
          </div>
        </div >
      )}
    </>

  );
}
export default Login;